module.exports = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  title: 'Modal',
  type: 'object',
  properties: {
    attributes: {
      title: 'Attributes (Twig-only)',
      type: 'object',
      description:
        'A Drupal attributes object. Used to apply additional HTML attributes to the outer &lt;bolt-modal&gt; tag.',
    },
    width: {
      type: 'string',
      description: 'Controls the width of the modal container.',
      default: 'optimal',
      enum: ['full', 'regular', 'optimal', 'auto'],
    },
    spacing: {
      type: 'string',
      description: 'Controls the spacing around the modal container.',
      default: 'medium',
      enum: ['none', 'small', 'medium', 'large'],
    },
    persistent: {
      description:
        'Enables the modal to be persistent. This will eliminate ways to close the modal and it is up to the author to provide a custom link to close the modal or redirect to another page within the modal content. Must be used in tandem with the <code>persistent_return_url</code> prop.',
      type: 'boolean',
      default: false,
    },
    persistent_return_url: {
      type: 'string',
      description:
        'The URL to be used on a return link. If a modal is persistent, a return link is required to provide the user a way out. Must be used in tandem with the <code>persistent</code> prop.',
    },
    theme: {
      type: 'string',
      description:
        'Controls the color theme of the modal container. <span class="u-bolt-color-error">Note: the values xlight, light, dark, xdark, xxdark are deprecated</span>.',
      default: 'white',
      enum: [
        'none',
        'white',
        'black',
        'gray-xlight',
        'navy-dark',
        'navy',
        'navy-light',
        'teal',
        'yellow',
        'orange',
        'pink',
        'wine',
        'berry',
        'violet',
      ],
    },
    scroll: {
      type: 'string',
      description: 'Controls the scrolling area.',
      default: 'container',
      enum: ['overall', 'container'],
    },
    uuid: {
      type: 'string',
      description: 'Unique ID for modal, randomly generated if not provided.',
    },
  },
};
